import React from 'react';
import { motion } from 'framer-motion';
import { Book, CheckCircle2 } from 'lucide-react';
export function SystemOverview() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — La Psicología de la Dueña',
    desc: 'Mentalidad empresarial, objetivos SMART, gestión del tiempo y plan de 90 días'
  }, {
    icon: '📗',
    title: 'Tomo 2 — Técnica con Sentido de Negocio',
    desc: 'Los 3 servicios más rentables, protocolos completos y sistema anti-reclamos'
  }, {
    icon: '📙',
    title: 'Tomo 3 — Arquitectura Financiera',
    desc: 'Costos reales, precio correcto, punto de equilibrio y sueldo de dueña'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Branding y Marketing',
    desc: 'Marca personal, Instagram que vende y captación de clientas sin publicidad paga'
  }, {
    icon: '📓',
    title: 'Tomo 5 — Experiencia y Fidelización',
    desc: 'Protocolo 5 estrellas, sistema de fidelización por niveles y agenda siempre llena'
  }, {
    icon: '📔',
    title: 'Tomo 6 — De la Mesa al Salón',
    desc: 'Monotributo, home studio profesional, primera asistente y escalamiento'
  }];
  const includes = ['Sistema paso a paso implementable desde el Día 1', 'Worksheets y planillas con tus datos reales', 'Scripts y textos listos para copiar y pegar', 'Checklists de implementación imprimibles', '100% adaptado al mercado argentino'];
  return <section className="py-16 px-4 pt-[15px] pb-[15px]" data-id="element-258">
      <div className="max-w-6xl mx-auto" data-id="element-259">
        <div className="text-center mb-12" data-id="element-260">
          <div className="inline-flex items-center space-x-2 bg-brand/10 text-brand px-4 py-2 rounded-full mb-6 font-bold" data-id="element-261">
            <Book className="w-5 h-5" data-id="element-262" />
            <span data-id="element-263">EL SISTEMA</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-264">
            🏆 ULTRAPACK MANICURISTA PRO™
          </h2>
          <p className="text-xl text-gray-400" data-id="element-265">
            6 Tomos + 6 Bonos — Todo el negocio resuelto
          </p>
          <p className="text-brand font-bold mt-2" data-id="element-266">
            500+ páginas. De Manicurista a Dueña Pro.
          </p>
        </div>

        <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-267">
          📚 LOS 6 TOMOS DEL SISTEMA
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-268">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-4 hover:border-brand/50 transition-colors" data-id="element-269">
              <div className="text-2xl mb-3" data-id="element-270">{tomo.icon}</div>
              <h4 className="text-lg font-bold mb-2" data-id="element-271">{tomo.title}</h4>
              <p className="text-gray-400 text-sm" data-id="element-272">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-dark-card border border-dark-border rounded-2xl p-8 max-w-3xl mx-auto" data-id="element-273">
          <h4 className="text-xl font-bold mb-6 text-center" data-id="element-274">
            Cada tomo incluye:
          </h4>
          <div className="space-y-4" data-id="element-275">
            {includes.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center space-x-3" data-id="element-276">
                <CheckCircle2 className="w-6 h-6 text-brand flex-shrink-0" data-id="element-277" />
                <span className="text-gray-300 text-lg" data-id="element-278">{item}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}